import { render, staticRenderFns } from "./FamilySearchHeaderTitle.vue?vue&type=template&id=1a6c6704"
import script from "./FamilySearchHeaderTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilySearchHeaderTitle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports